'use client';

import React, { useEffect, useRef, useState } from 'react';

import { RevealProps } from './models';

const Reveal = ({ children, delay = 0, className = '' }: RevealProps) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setVisible(true);
            return;
        }

        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={`transition-[opacity,transform] duration-[600ms] ease-[cubic-bezier(0.22,1,0.36,1)] will-change-[opacity,transform] ${
                visible ? 'translate-y-0 opacity-100' : 'translate-y-7 opacity-0'
            } ${className}`}
            style={delay ? ({ transitionDelay: `${delay}ms` } as React.CSSProperties) : undefined}>
            {children}
        </div>
    );
};

export default Reveal;
